export var MAX_CHARACTERS_LIMIT = 1000;
